// extracted by mini-css-extract-plugin
export default {"container":"CookiePolicy_container__ZfknE","chatLink":"CookiePolicy_chatLink__z1T9N"};